import { RyuseiCode } from '../../core/RyuseiCode/RyuseiCode';
import * as Extensions from '../../extensions';


RyuseiCode.compose( Extensions );

export { RyuseiCode as default } from '../../core/RyuseiCode/RyuseiCode';
